"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KIND = exports.VARIANT = exports.COLOR_STYLE_KEYS = void 0;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// Remove this in the next major version


var COLOR_STYLE_KEYS = {
  neutral: 'tagNeutralBackground',
  primary: 'tagPrimaryBackground',
  positive: 'tagPositiveBackground',
  warning: 'tagWarningBackground',
  negative: 'tagNegativeBackground'
};
exports.COLOR_STYLE_KEYS = COLOR_STYLE_KEYS;
var VARIANT = Object.freeze({
  solid: 'solid',
  light: 'light',
  outlined: 'outlined'
});
exports.VARIANT = VARIANT;
var KIND = Object.keys(_objectSpread({}, COLOR_STYLE_KEYS, {
  custom: null
})).reduce(function (kindMap, key) {
  kindMap[key] = key;
  return kindMap;
}, {});
exports.KIND = KIND;